<div class="container pt-4">
  <div class="row">
    <div class="col-lg-6 offset-lg-3">
      <div class="card text-center">
        <div class="card-body">
          <h5>
            {{ title }}
            <div *ngIf="loading" class="spinner-grow float-rigth" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </h5>
          <span
            *ngIf="submited && createEmpleado.invalid"
            class="badge bg-danger"
            >Todos los campos son obligatorios</span
          >
          <form
            class="mt-4"
            [formGroup]="createEmpleado"
            (ngSubmit)="addEmpleado()"
          >
            <div class="row">
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  formControlName="nombre"
                  placeholder="Nombre"
                />
              </div>
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Apellido"
                  formControlName="apellido"
                />
              </div>
            </div>
            <input
              type="text"
              class="form-control mt-3"
              placeholder="Documento"
              formControlName="documento"
            />
            <input
              type="number"
              class="form-control mt-3"
              placeholder="Salario"
              formControlName="salario"
            />
            <div class="mt-3 d-flex justify-content-around">
              <button
                type="text"
                routerLink="/list"
                class="btn btn-lg btn-secondary"
              >
                Volver
              </button>
              <button type="submit" class="btn btn-lg btn-dark">Agregar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
